

exports.__esModule = true;
exports.$ChoiceEligibility = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('../auth');

var _checkout = require('../checkout');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Variants:
// control
// 2 - multiple FI on RYI
// 3 - FI page
// 4 - preferred checkbox
// 5 - multipl FI on RYI + preferred checkbox
// 6 - FI page + preferred checkbox on RYI

// Individual variant eligibility checks
var multipleFiEligibility = function multipleFiEligibility(token, _ref) {
    var checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel;

    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);
        return installmentOptions.save({
            cache: true, // Cache response for selectFi page or wherever needed
            data: {
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppDataModel,
                isMemberCredit: true
            },
            success: function success(result) {
                var offers = result.installments && result.installments[0];
                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                return !hasInstallments;
            },
            contingencies: {
                DEFAULT: function DEFAULT(message) {
                    // Assume is eligible if contingency
                    _logger.$logger.info('installments_contingency', {
                        message: message
                    });
                    return true;
                }
            },
            error: function error(err) {
                _logger.$logger.info('installments_error', err);
                return true;
            }
        });
    } else {
        return _squid.$promise.resolve(true);
    }
};

// Main logic to decide choice eligibility
var decideEligibility = function decideEligibility(token, _ref2) {
    var authModel = _ref2.authModel,
        checkoutCartModel = _ref2.checkoutCartModel,
        checkoutSessionModel = _ref2.checkoutSessionModel,
        checkoutAppDataModel = _ref2.checkoutAppDataModel,
        checkoutPayeeModel = _ref2.checkoutPayeeModel;
    var plan = checkoutSessionModel.plan,
        fundingOptions = checkoutSessionModel.fundingOptions;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Reasons for a transaction to be ineligible:
    //  - Doesn't meet pxp
    //  - is MSB
    //  - is billing
    //  - is split balance
    //  - balance covers full transaction but does not have preferred set
    //  - has PAD
    //  - is second button
    //  - is not US
    //  - has currency conversion
    //  - is not a merchant account

    // Check to see if any plans include split balance
    var splitBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.secondaryFIs;
    });
    var MSB = plan.isMSB();
    var billing = checkoutCartModel.isBilling();
    var PAD = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.subtype === 'PAD';
    });
    var secondButton = checkoutAppDataModel.is_second_button_txn;
    var isUS = checkoutAppDataModel.merchant.merchant_country === 'US';
    var fullBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.type === 'BALANCE';
    });
    var hasPreferred = fundingOptions.getPreferred();
    var isNotMerchantAccount = authModel.account_type !== 2;

    var involvedCurrencies = {};
    if (checkoutCartModel.get('purchase.amounts.total.currency_code') && plans) {
        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
        plans.forEach(function (option) {
            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
        });
    }

    var singleCurrency = _lodash2['default'].size(involvedCurrencies) <= 1;

    var choiceVariantsName = 'xo_hermes_choice_variant_(?:preferred_newusers_)?treatment_(.*)';

    // Check the global preferred experiment and the choice variant.
    // User must pass the global preferred experiment to be eligible to see a variant
    return (0, _squid.$pxp)('xo_hermes_choice_variant', choiceVariantsName).then(function (choiceVariant) {

        // Check transaction eligibility
        var eligibilityCriteria = {
            'pxpVariant': choiceVariant,
            'noMSB': !MSB,
            'noBilling': !billing,
            'noSplitBalance': !splitBalance,
            'balanceWithPreferred': !(fullBalance && !hasPreferred),
            'noPAD': !PAD,
            'noSecondButton': !secondButton,
            'isUS': isUS,
            'singleCurrency': singleCurrency,
            'noMerchant': isNotMerchantAccount
        };
        var ineligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
            return !eligibilityCriteria[key];
        });
        var transactionEligible = ineligibleReasons.length === 0;

        if (!transactionEligible) {
            _logger.$logger.info('choice_experiment_ineligible', {
                failed: ineligibleReasons.join(',')
            });

            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOICE_ELG_CHK',
                'to': 'process_choice_elg_chk',
                'eligibility_reason': 'pxp_control-' + ineligibleReasons.join(',')
            });

            return 'control';
        }

        var variant = choiceVariant.treatment_name.match(choiceVariantsName)[1];

        // If individual variantEligibility checks are needed
        var variantEligibility = {};
        var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
        var getVariantEligibility = null;

        multipleFiVariants.forEach(function (multiVariant) {
            variantEligibility[multiVariant] = multipleFiEligibility;
        });

        if (variantEligibility[variant]) {
            getVariantEligibility = variantEligibility[variant](token, { checkoutCartModel: checkoutCartModel, checkoutSessionModel: checkoutSessionModel, checkoutAppDataModel: checkoutAppDataModel, checkoutPayeeModel: checkoutPayeeModel });
        } else {
            getVariantEligibility = _squid.$promise.resolve(true);
        }

        return getVariantEligibility.then(function (variantEligible) {
            if (!variantEligible) {
                _logger.$logger.info('choice_experiment_ineligible', {
                    failed: 'variant_' + variant + '_eligibility'
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'CHOICE_ELG_CHK',
                    'to': 'process_choice_elg_chk',
                    'eligibility_reason': 'pxp_control-creditInstallments'
                });

                return 'control';
            }

            _logger.$logger.info('choice_experiment_eligible', {
                variant: variant
            });

            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOICE_ELG_CHK',
                'to': 'process_choice_elg_chk',
                'eligibility_reason': 'pxp_treatment'
            });

            return variant;
        });
    });
};

var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
    getVariant: function getVariant(token) {

        // Check if cached so we can avoid rerunning the decision logic
        if (this.variant) {
            return this.variant;
        }

        if (!(0, _squid.$feature)('choiceExperiment')) {
            this.variant = _squid.$promise.resolve(true);

            return this.variant;
        }

        var models = {};

        this.variant = (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
        }).then(function () {
            return decideEligibility(token, models);
        });

        return this.variant;
    }
});

_squid.$Model;

_squid.$pxp;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$InstallmentOptionsModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/choice/index.js
// module id = ./components/xo-models/src/choice/index.js
// module chunks = 1